export const curriculum = {
  // ヘッダー
  title: 'カリキュラム進捗',
  subtitle: 'A → B1 → B2 → C の4段階で着実にレベルアップ',

  // ステップ表示
  currentLevelLabel: '現在のレベル',
  currentBadge: '現在地',
  completedBadge: '修了',
  upcomingBadge: 'これから',

  // レベル説明
  levelADesc: '完全初心者。基本的な語彙と文法の基礎を学びます。',
  levelB1Desc: '中級基礎。日常会話の流暢さを構築し、語彙を拡大します。',
  levelB2Desc: 'プロフェッショナルレベル。ニュアンスや慣用句を磨きます。',
  levelCDesc: 'ネイティブに近い流暢さ。高度な表現をマスターします。',

  // レベルアップ移行（テスト＋補強2回）
  levelUpTitle: 'レベルアップ',
  levelUpDescription: '1回のテスト + 家庭教師による弱点補強レッスン2回',

  // 進捗メトリクス
  completedLessons: '完了レッスン',
  completedLessonsUnit: '回',
  remainingLessons: '残りレッスン',
  remainingLessonsUnit: '回',
  levelTest: 'レベルアップテスト',
  levelTestPassed: '合格',
  levelTestNotPassed: '未受験',
  weakAreasTitle: '弱点補強の対象',
  weakAreasEmpty: '現在記録されている弱点はありません',

  // 残レッスンが取得できない/サブスク未登録
  noSubscription: 'プランに登録するとレッスンを受けられます',
  viewPlans: 'プランを見る',

  // 状態
  loading: '読み込み中...',
  loadError: '進捗データの取得に失敗しました。時間をおいて再度お試しください。',
  retry: '再読み込み',

  // アディショナルプラン（プレースホルダ）
  additionalTitle: 'アディショナルプラン',
  additionalBadge: '近日公開',
  additionalSubtitle: 'A〜Cレベル修了後に選べる専門コース。準備が整い次第ご案内します。',
  additionalWorkplace: '職場系コース',
  additionalWorkplaceDesc: 'キッチン・ホテル・接客などの仕事環境フレーズ',
  additionalWordplay: '言葉遊び系コース',
  additionalWordplayDesc: '略語・ことわざ・スラング',
  additionalComingSoon: '準備中',
  additionalSelectPlaceholder: 'コースを選択（近日公開）',
};
